export enum ShopType {
  BOTH = "BOTH",
  MILLING_AND_TURNING = "MILLING_AND_TURNING",
  SHEET_METAL = "SHEET_METAL",
}
